<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import Grid from '../Shared/Grid'
const moment = require('moment')

export default {
  name: 'StudentClassesTab',
  props: ['studentForm', 'validation'],
  components: {
    Grid
  },
  data () {
    return {
      moment: moment,
      module: this.$route.meta.module,
      columnOptions: [
        { field: 'CLASS_ID', name: 'CLASS_ID', label: 'Class ID', sortable: false, filterable: false, filter: '', type: 'string' },
        { field: 'CLASS_START_DATE', name: 'CLASS_START_DATE', label: 'Class Start Date', sortable: true, filterable: true, filter: { start: null, end: null },  type: 'date' },
        { field: 'CLASS_END_DATE', name: 'CLASS_END_DATE', label: 'Class End Date', sortable: true, filterable: true, filter: { start: null, end: null },  type: 'date' },
        { field: 'STATUS', name: 'STATUS', label: 'Status', sortable: false, filterable: false, filter: '', type: 'string' }
      ]
    }
  },
  computed: {
    ...mapState('students', {
      classes: state => state.studentClassList,
    }),
    ...mapGetters('students', [
    ])
  },
  methods: {
    ...mapActions('students', [
      'fetchStudentClasses'
    ]),
    ...mapMutations('students', [
    ])
  }
}
</script>

<template>
  <div class="fit">
    <Grid
      :module="module"
      :data="classes"
      :columns="columnOptions"
      :onRequest="fetchStudentClasses"
    />
  </div>
</template>

<style>
</style>
